function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M23 15c-4.4 0-8 3.6-8 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm3.7 8.7l-3.1 3c-.2.2-.4.3-.7.3-.3 0-.5-.1-.7-.3-.4-.4-.4-1 0-1.4l1.3-1.3H19c-.6 0-1-.4-1-1s.4-1 1-1h4.5l-1.3-1.3c-.4-.4-.4-1 0-1.4.4-.4 1-.4 1.4 0l3.1 3c.2.2.3.4.3.7s-.1.5-.3.7z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M13 23c0-1.4.3-2.8.9-4-.2 0-.4-.1-.5-.2l-1.6-1.4-5.1 4.4c-.2.1-.5.2-.7.2-.3 0-.6-.1-.8-.3-.4-.4-.3-1 .1-1.4l4.9-4.2-4.9-4.2c-.4-.4-.5-1-.1-1.4.4-.4 1-.5 1.4-.1l7.3 6.4 7.3-6.4c.4-.4 1-.3 1.4.1.4.4.3 1-.1 1.4L21 13.2c.6-.1 1.3-.2 2-.2 1.4 0 2.8.3 4 .8V9c0-1.7-1.3-3-3-3H4C2.3 6 1 7.3 1 9v14c0 1.7 1.3 3 3 3h9.5c-.3-.9-.5-2-.5-3z"
});

function SvgSendEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendEmail);
export default __webpack_public_path__ + "static/media/send-email.500187a5.svg";
export { ForwardRef as ReactComponent };